var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoWatter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.5,
  height: 46.5,
  x: 0.75,
  y: 0.75,
  stroke: "#183690",
  strokeWidth: 1.5,
  rx: 23.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#183690",
  d: "M14.555 12.5a.75.75 0 0 0-1.11 1l2.962 3.259C14.314 19.866 13.25 22.97 13.25 26a10.75 10.75 0 0 0 18.41 7.541l1.785 1.959a.75.75 0 0 0 1.11-1.01zM24 35.25A9.26 9.26 0 0 1 14.75 26c0-2.625.909-5.345 2.699-8.091l13.199 14.519A9.23 9.23 0 0 1 24 35.25m-4.575-21.116a.75.75 0 0 1-.025-1.062 30.7 30.7 0 0 1 4.17-3.686.75.75 0 0 1 .86 0 31.4 31.4 0 0 1 5.136 4.75c3.392 3.896 5.184 8 5.184 11.864 0 .966-.13 1.927-.385 2.859a.75.75 0 1 1-1.446-.398c.22-.802.332-1.63.331-2.461 0-7.454-7.375-13.617-9.25-15.065a32 32 0 0 0-3.515 3.172.75.75 0 0 1-1.06.027"
})));
export default SvgNoWatter;